import React, { useRef, useEffect } from 'react';
import styled from 'styled-components';

const Container = styled.div`
  width: 100%;
  ${({ active }) => !active && 'display: none;'}
`;

const TabPane = React.memo(({ active, children }: Object) => {
  const _isActived = useRef();
  useEffect(() => {
    _isActived.current = _isActived.current || active;
  });
  const shouldRender = _isActived.current || active;
  return (
    <Container active={active} className="tab-panel">
      {shouldRender && children}
    </Container>
  );
});

export default TabPane;
